module.exports = __webpack_public_path__ + "img/about-earth.51cb3cf7.png";